// extracted by mini-css-extract-plugin
export default {"root":"tFWEweVdNlOsxJhr_ezu","placeHolderShimmer":"KIkZyuox_71EWPvfz38E"};